/** @format */

import React, { useEffect, useState, useRef } from 'react'
import './index.less'

const imgs = [
  {
    url:
      'https://image.linggan.znzmo.com/91da8b481202b55413b8c12d00729df5030e8137.jpg',
    width: 680,
    height: 1020,
  },
  {
    url:
      'https://image.linggan.znzmo.com/c42c57b902fbe52d999cc95e32f06a10aa0063b4.jpg',
    width: 680,
    height: 907,
  },
  {
    url:
      'https://image.linggan.znzmo.com/38194871929cf4cb6b9712583c92dc72f00e48bb.jpg',
    width: 680,
    height: 680,
  },
  {
    url:
      'https://image.linggan.znzmo.com/91da8b481202b55413b8c12d00729df5030e8137.jpg',
    width: 680,
    height: 1020,
  },
  {
    url:
      'https://image.linggan.znzmo.com/c42c57b902fbe52d999cc95e32f06a10aa0063b4.jpg',
    width: 680,
    height: 907,
  },
  {
    url:
      'https://image.linggan.znzmo.com/38194871929cf4cb6b9712583c92dc72f00e48bb.jpg',
    width: 680,
    height: 680,
  },
  {
    url:
      'https://image.linggan.znzmo.com/91da8b481202b55413b8c12d00729df5030e8137.jpg',
    width: 680,
    height: 1020,
  },
  {
    url:
      'https://image.linggan.znzmo.com/c42c57b902fbe52d999cc95e32f06a10aa0063b4.jpg',
    width: 680,
    height: 907,
  },
  {
    url:
      'https://image.linggan.znzmo.com/38194871929cf4cb6b9712583c92dc72f00e48bb.jpg',
    width: 680,
    height: 680,
  },
  {
    url:
      'https://image.linggan.znzmo.com/38194871929cf4cb6b9712583c92dc72f00e48bb.jpg',
    width: 680,
    height: 680,
  },
]

export default () => {
  const refUl = useRef('');
  const [ liContent, setLiContent ] = useState([]);
  useEffect(() => {
    waterFallInit();
  }, []);
  const waterFallInit = () => {
    const ul = refUl.current;
    const clientWidth = ul.clientWidth;
    const cellWidth = (clientWidth / 5) - 10;
    const ratio = cellWidth / imgs[0].width;
    const liHeightList = new Array(5).fill(0);
    const liContentList = new Array();
    for (let i = 0; i < 5; i ++) {
      liContentList.push(new Array());
    }
    for (let i = 0; i < imgs.length; i ++) {
      if (i < 5) {
        let height = imgs[i].height * ratio;
        let element = <div key={i}><img src={imgs[i].url} width={cellWidth + 'px'} height={height + 'px'}/><div className='cross'>×</div></div>;
        liContentList[i].push(element);
        liHeightList[i] += height;
        continue;
      }
      let minIndex = 0;
      const minValue = Math.min(...liHeightList);
      minIndex = liHeightList.indexOf(minValue);
      let height = imgs[i].height * ratio;
      let element = <div key={i}><img src={imgs[i].url} width={cellWidth + 'px'} height={height + 'px'}/><div className='cross'>×</div></div>;
      liHeightList[minIndex] += height;
      liContentList[minIndex].push(element);
    }
    setLiContent(liContentList);
  }
  return (
    <div className='insGroupWaterfallContainer'>
      <ul ref={refUl}>
        {
          new Array(5).fill('').map((item, index) => {
            return (
            <li 
              key={index}
            >
              {
                liContent.length > 0 
                && (
                  liContent[index].map((value, i) => {
                    return value;
                  })
                )
              }
            </li>
          )})
        }
      </ul>
    </div>
  )
}
